"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubConnaissancesMarcheImmobilier = void 0;
exports.ESubConnaissancesMarcheImmobilier = {
    aucune: "aucune",
    faible: "faible",
    moyenne: "moyenne",
    eleve: "eleve",
    expert: "expert",
};
